import React from 'react'

const Loading = () => {
    return (
        <div className="d-flex justify-content-center">
            <div
                className="spinner spinner-border"
                role="status"
                style={{
                    color: "",
                    backgroundColor: "",
                    top: "50%",
                    left: "50%",
                    width: "3rem",
                    height: "3rem"
                }}
            >
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default Loading